import * as slideCrudActions from 'actions/livefeed/slideCrudActions'
import defaultEditorState from 'components/pages/livefeed/defaultstate';
import update from 'immutability-helper';

const initialState = defaultEditorState;

export default (state = initialState, action) => {
    switch (action.type) {
        // ------------------------------------slide state update
        case slideCrudActions.GO_TO_SLIDE: {
            return update(state, {
                slideCurrentIndex: { $set: action.index }
            })
        }
        case slideCrudActions.ADD_SLIDE: {
            return update(state, {
                livefeedSlides: { $push: [action.objectSlide] }
            })
        }
        case slideCrudActions.ADD_SUM_SLIDE: {
            return update(state, {
                livefeedSlides: { $unshift: [action.objectSlide] }
            })
        }
        case slideCrudActions.REMOVE_SLIDE: {
            return update(state, {
                livefeedSlides: { $splice: [[action.slideIndex, 1]] }
            })
        }
        case slideCrudActions.SORT_SLIDE_ORDER: {
            return update(state, {
                livefeedSlides: { $set: action.newOrder }
            })
        }
        default: {
            return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/livefeededitor/slideCrudReducer.js